import { formatBool } from '@/utils/shared';
import dateFormatter from '@/services/formatter_services/date-formatter';
import TRUNCATE_UNITS from '@/utils/enum/TRUNCATE_UNITS';

const DEVICE_WIDGETS = Object.freeze({
  DEVICE_WIDGETS: [
    {
      id: 'devices',
      path: 'devices',
      getData: response => response.data.data?.map(item => item.data),
      headers: [
        {
          text: 'Devices.words.customerInfo',
          value: 'label',
          truncateUnit: TRUNCATE_UNITS.STRING,
          truncateAfter: 20,
        },
        {
          text: 'Common.serialNumber',
          value: 'serialNumber',
          truncateUnit: TRUNCATE_UNITS.STRING,
          truncateAfter: 20,
        },
        {
          text: 'words.manufacturerSerialNumber',
          value: 'manufacturerSerialNumber',
          truncateUnit: TRUNCATE_UNITS.STRING,
          truncateAfter: 20,
        },
        {
          text: 'words.contactId',
          value: 'ownerCustomerNumber',
          isHiddenByDefault: false,
        },
        {
          text: 'Common.owner',
          value: 'customerName',
          truncateUnit: TRUNCATE_UNITS.STRING,
          truncateAfter: 20,
        },
        {
          text: 'Common.street',
          value: 'ownerStreet',
          truncateUnit: TRUNCATE_UNITS.STRING,
          truncateAfter: 20,
        },
        {
          text: 'Common.zipCode',
          value: 'ownerZipCode',
          truncateUnit: TRUNCATE_UNITS.STRING,
          truncateAfter: 20,
        },
        {
          text: 'Common.location',
          value: 'ownerCity',
          truncateUnit: TRUNCATE_UNITS.STRING,
          truncateAfter: 20,
        },
        {
          text: 'Common.country',
          value: 'ownerCountry',
          truncateUnit: TRUNCATE_UNITS.STRING,
          truncateAfter: 20,
        },
        {
          text: 'Devices.sentences.ownerEmail',
          value: 'ownerEmail',
          truncateUnit: TRUNCATE_UNITS.STRING,
          truncateAfter: 20,
        },
        {
          text: 'Common.salutation',
          value: 'contactSalutation',
          isHiddenByDefault: true,
        },
        {
          text: 'Devices.sentences.contactFirstName',
          value: 'contactFirstname',
        },
        {
          text: 'Devices.sentences.contactLastName',
          value: 'contactLastname',
        },
        {
          text: 'Devices.sentences.contactEmail',
          value: 'contactEmail',
          truncateUnit: TRUNCATE_UNITS.STRING,
          truncateAfter: 20,
        },
        {
          text: 'Common.phone',
          value: 'contactPhone',
        },
        {
          text: 'Common.product',
          value: 'productLabel',
          truncateUnit: TRUNCATE_UNITS.STRING,
          truncateAfter: 20,
        },
        {
          text: 'Common.producer',
          value: 'producerName',
          truncateUnit: TRUNCATE_UNITS.STRING,
          truncateAfter: 20,
        },
        {
          text: 'words.categories',
          value: 'connectedCategoryLabels',
          truncateUnit: TRUNCATE_UNITS.ARRAY,
          truncateAfter: 2,
          isHiddenByDefault: true,
        },
        {
          text: 'Common.status',
          value: 'statusLabel',
          truncateUnit: TRUNCATE_UNITS.STRING,
          truncateAfter: 20,
        },
        {
          text: 'Common.type',
          value: 'typeLabel',
          truncateUnit: TRUNCATE_UNITS.STRING,
          truncateAfter: 20,
        },
        {
          text: 'Devices.words.hasMaintenance',
          value: 'hasMaintenance',
          presentWith: formatBool,
        },
        {
          text: 'Dashboard.widgets.devices.headers.lastMaintenance',
          text: 'Devices.words.lastMaintenance',
          value: 'lastMaintenance',
          presentWith: dateFormatter.formatDateToLocaleDateStringNoTime,
        },
        {
          text: 'Devices.words.maintenanceRecommendation',
          value: 'nextMaintenance',
          presentWith: dateFormatter.formatDateToLocaleDateStringNoTime,
        },
        {
          text: 'Devices.words.protocolNumber',
          value: 'echeckProtocolNumber',
          truncateUnit: TRUNCATE_UNITS.STRING,
          truncateAfter: 20,
        },
        {
          text: 'words.exportCount',
          value: 'exportCount',
        },
        {
          text: 'words.lastExport',
          value: 'lastExport',
          presentWith: dateFormatter.formatDateToLocaleDateString,
        },
        {
          text: 'Search.words.deleted',
          value: 'isDeleted',
          presentWith: formatBool,
        },
      ],
      type: 'TABLE',
      moduleId: 'devices',
      withRouterActionLink: true
    },
    {
      id: 'devicesAmount',
      path: 'devices',
      type: 'VALUE',
      getData: response => response.data.totalHits,
      moduleId: 'devices'
    }
  ]
});

export default DEVICE_WIDGETS;
